<template>
  <div class="page-body">
    <div class="container">
      <b-alert
        variant="warning"
        show
      >
        No Access
      </b-alert>
    </div>
  </div>
</template>

<script>
export default {
};
</script>
